import { render } from "./OfferList.vue?vue&type=template&id=1491f4f8"
import script from "./OfferList.vue?vue&type=script&lang=js"
export * from "./OfferList.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./OfferList.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_09d06e80%2Fpackages%2Finsurer%2Fsrc%2Fviews%2Foffers%2FOfferList.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__